import gql from 'graphql-tag'

export const fetchOrganizationsSignatureSelect = () => {
	return {
		query: gql`
			{
				organizations: organizations(
					where: { active: { _eq: true }, active_signature: { _eq: true } }
					order_by: { name: asc }
				) {
					id
					name
				}
			}
		`
	}
}
